/**
 * 透明色。
 */
export const transparent = "rgba(255, 255, 255, 0)";

/**
 * 无色。
 */
export const none = "rgba(0, 0, 0, 0)";

/**
 * 爱丽丝蓝色。
 */
export const aliceBlue = "#f0f8ff";

/**
 * 古董白色。
 */
export const antiqueWhite = "#faebd7";

/**
 * 水绿色。
 */
export const aqua = "#00ffff";

/**
 * 碧绿色。
 */
export const aquamarine = "#7fffd4";

/**
 * 蔚蓝色。
 */
export const azure = "#f0ffff";

/**
 * 米黄色。
 */
export const beige = "#f5f5dc";

/**
 * 橘黄色。
 */
export const bisque = "#ffe4c4";

/**
 * 黑色。
 */
export const black = "#000000";

/**
 * 白杏色。
 */
export const blanchedAlmond = "#ffebcd";

/**
 * 蓝色。
 */
export const blue = "#0000ff";

/**
 * 蓝紫色。
 */
export const blueViolet = "#8a2be2";

/**
 * 棕色。
 */
export const brown = "#a52a2a";

/**
 * 原木色。
 */
export const burlywood = "#deb887";

/**
 * 军校蓝色。
 */
export const cadetBlue = "#5f9ea0";

/**
 * 查特酒绿色。
 */
export const chartreuse = "#7fff00";

/**
 * 巧克力色。
 */
export const chocolate = "#d2691e";

/**
 * 珊瑚色。
 */
export const coral = "#ff7f50";

/**
 * 矢车菊蓝色。
 */
export const cornflowerBlue = "#6495ed";

/**
 * 玉米黄色。
 */
export const cornsilk = "#fff8dc";

/**
 * 猩红色。
 */
export const crimson = "#dc143c";

/**
 * 青色。
 */
export const cyan = "#00ffff";

/**
 * 深蓝色。
 */
export const darkBlue = "#00008b";

/**
 * 深青色。
 */
export const darkCyan = "#008b8b";

/**
 * 深秋麒麟色。
 */
export const darkGoldenrod = "#b8860b";

/**
 * 深灰色。
 */
export const darkGray = "#a9a9a9";

/**
 * 深绿色。
 */
export const darkGreen = "#006400";

/**
 * 深土黄色。
 */
export const darkKhaki = "#bdb76b";

/**
 * 深洋紫色。
 */
export const darkMagenta = "#8b008b";

/**
 * 深橄榄绿色。
 */
export const darkOliveGreen = "#556b2f";

/**
 * 深橘色。
 */
export const darkOrange = "#ff8c00";

/**
 * 深兰花紫色。
 */
export const darkOrchid = "#9932cc";

/**
 * 深红色。
 */
export const darkRed = "#8b0000";

/**
 * 深肉色。
 */
export const darkSalmon = "#e9967a";

/**
 * 深海洋绿色。
 */
export const darkSeaGreen = "#8fbc8f";

/**
 * 深岩暗蓝灰色。
 */
export const darkSlateBlue = "#483d8b";

/**
 * 深石板灰色。
 */
export const darkSlategray = "#2f4f4f";

/**
 * 深绿宝石色。
 */
export const darkTurquoise = "#00ced1";

/**
 * 深紫罗兰色。
 */
export const darkViolet = "#9400d3";

/**
 * 深粉色。
 */
export const deepPink = "#ff1493";

/**
 * 深天蓝色。
 */
export const deepSkyBlue = "#00bfff";

/**
 * 暗淡灰色。
 */
export const dimGray = "#696969";

/**
 * 道奇蓝色。
 */
export const dodgerBlue = "#1e90ff";

/**
 * 耐火砖色。
 */
export const fireBrick = "#b22222";

/**
 * 花白色。
 */
export const floralWhite = "#fffaf0";

/**
 * 森林绿色。
 */
export const forestGreen = "#228b22";

/**
 * 海棠紫红色。
 */
export const fuchsia = "#ff00ff";

/**
 * 亮灰色。
 */
export const gainsboro = "#dcdcdc";

/**
 * 幽灵白色。
 */
export const ghostWhite = "#f8f8ff";

/**
 * 金色。
 */
export const gold = "#ffd700";

/**
 * 麒麟黄色。
 */
export const goldenrod = "#daa520";

/**
 * 灰色。
 */
export const gray = "#808080";

/**
 * 绿色。
 */
export const green = "#008000";

/**
 * 绿黄色。
 */
export const greenYellow = "#adff2f";

/**
 * 蜂蜜色。
 */
export const honeydew = "#f0fff0";

/**
 * 热情粉色。
 */
export const hotPink = "#ff69b4";

/**
 * 印度红色。
 */
export const indianRed = "#cd5c5c";

/**
 * 靛青色。
 */
export const indigo = "#4b0082";

/**
 * 象牙色。
 */
export const ivory = "#fffff0";

/**
 * 卡其布色。
 */
export const khaki = "#f0e68c";

/**
 * 熏衣草花的淡紫色。
 */
export const lavender = "#e6e6fa";

/**
 * 苍白的紫罗兰红色。
 */
export const lavenderBlush = "#fff0f5";

/**
 * 草坪绿色。
 */
export const lawnGreen = "#7cfc00";

/**
 * 柠檬薄纱色。
 */
export const lemonChiffon = "#fffacd";

/**
 * 浅蓝色。
 */
export const lightBlue = "#add8e6";

/**
 * 淡珊瑚色。
 */
export const lightCoral = "#f08080";

/**
 * 淡青色。
 */
export const lightCyan = "#e0ffff";

/**
 * 浅秋麒麟黄色。
 */
export const lightGoldenrodYellow = "#fafad2";

/**
 * 浅灰色。
 */
export const lightGray = "#d3d3d3";

/**
 * 淡绿色。
 */
export const lightGreen = "#90ee90";

/**
 * 浅粉色。
 */
export const lightPink = "#ffb6c1";

/**
 * 浅肉色。
 */
export const lightSalmon = "#ffa07a";

/**
 * 浅海洋绿色。
 */
export const lightSeaGreen = "#20b2aa";

/**
 * 淡蓝色。
 */
export const lightSkyBlue = "#87cefa";

/**
 * 浅石板灰色。
 */
export const lightSlategray = "#778899";

/**
 * 淡钢蓝色。
 */
export const lightSteelblue = "#b0c4de";

/**
 * 浅黄色。
 */
export const lightYellow = "#ffffe0";

/**
 * 酸橙色。
 */
export const lime = "#00ff00";

/**
 * 酸橙绿色。
 */
export const limeGreen = "#32cd32";

/**
 * 亚麻布色。
 */
export const linen = "#faf0e6";

/**
 * 洋红色。
 */
export const magenta = "#ff00ff";

/**
 * 栗色。
 */
export const maroon = "#800000";

/**
 * 适中的碧绿色。
 */
export const mediumAquamarine = "#66cdaa";

/**
 * 适中的蓝色。
 */
export const mediumBlue = "#0000cd";

/**
 * 适中的兰花紫色。
 */
export const MediumOrchid = "#ba55d3";

/**
 * 适中的紫色。
 */
export const mediumPurple = "#9370d8";

/**
 * 适中的海洋绿色。
 */
export const mediumSeaGreen = "#3cb371";

/**
 * 适中的板岩暗蓝灰色。
 */
export const mediumSlateBlue = "#7b68ee";

/**
 * 适中的春天的绿色。
 */
export const mediumSpringGreen = "#00fa9a";

/**
 * 适中的绿宝石色。
 */
export const mediumTurquoise = "#48d1cc";

/**
 * 适中的紫罗兰红色。
 */
export const mediumVioletRed = "#c71585";

/**
 * 午夜的蓝色。
 */
export const midnightBlue = "#191970";

/**
 * 薄荷奶油色。
 */
export const mintCream = "#f5fffa";

/**
 * 薄雾玫瑰色。
 */
export const mistyRose = "#ffe4e1";

/**
 * 鹿皮鞋色。
 */
export const moccasin = "#ffe4b5";

/**
 * 纳瓦霍白色。
 */
export const navajoWhite = "#ffdead";

/**
 * 海军蓝色。
 */
export const navy = "#000080";

/**
 * 老饰带色。
 */
export const oldLace = "#fdf5e6";

/**
 * 橄榄色。
 */
export const olive = "#808000";

/**
 * 橄榄土褐色。
 */
export const oliveDrab = "#6b8e23";

/**
 * 橙色。
 */
export const orange = "#ffa500";

/**
 * 橙红色。
 */
export const orangeRed = "#ff4500";

/**
 * 兰花的紫色。
 */
export const orchid = "#da70d6";

/**
 * 淡菊黄色。
 */
export const paleGoldenrod = "#eee8aa";

/**
 * 苍白的绿色。
 */
export const paleGreen = "#98fb98";

/**
 * 苍白的绿宝石色。
 */
export const paleTurquoise = "#afeeee";

/**
 * 苍白的紫罗兰红色。
 */
export const paleVioletred = "#d87093";

/**
 * 番木瓜色。
 */
export const papayaWhip = "#ffefd5";

/**
 * 桃色。
 */
export const peachPuff = "#ffdab9";

/**
 * 秘鲁色。
 */
export const peru = "#cd853f";

/**
 * 粉红色。
 */
export const pink = "#ffc0cb";

/**
 * 李子色。
 */
export const plum = "#dda0dd";

/**
 * 火药蓝色。
 */
export const powderBlue = "#b0e0e6";

/**
 * 紫色。
 */
export const purple = "#800080";

/**
 * 红色。
 */
export const red = "#ff0000";

/**
 * 玫瑰棕色。
 */
export const rosyBrown = "#bc8f8f";

/**
 * 皇军蓝色。
 */
export const royalBlue = "#4169e1";

/**
 * 马鞍棕色。
 */
export const saddleBrown = "#8b4513";

/**
 * 肉色。
 */
export const salmon = "#fa8072";

/**
 * 沙棕色。
 */
export const sandyBrown = "#f4a460";

/**
 * 海洋绿色。
 */
export const seaGreen = "#2e8b57";

/**
 * 海贝壳色。
 */
export const seaShell = "#fff5ee";

/**
 * 黄土赭色。
 */
export const sienna = "#a0522d";

/**
 * 银白色。
 */
export const silver = "#c0c0c0";

/**
 * 天蓝色。
 */
export const skyBlue = "#87ceeb";

/**
 * 板岩暗蓝灰色。
 */
export const slateBlue = "#6a5acd";

/**
 * 石板灰色。
 */
export const slateGray = "#708090";

/**
 * 雪白色。
 */
export const snow = "#fffafa";

/**
 * 春绿色。
 */
export const springGreen = "#00ff7f";

/**
 * 钢蓝色。
 */
export const steelBlue = "#4682b4";

/**
 * 晒黑色。
 */
export const tan = "#d2b48c";

/**
 * 鸭绿色。
 */
export const teal = "#008080";

/**
 * 蓟色。
 */
export const thistle = "#d8bfd8";

/**
 * 番茄色。
 */
export const tomato = "#ff6347";

/**
 * 绿宝石色。
 */
export const turquoise = "#40e0d0";

/**
 * 紫罗兰色。
 */
export const violet = "#ee82ee";

/**
 * 小麦色。
 */
export const wheat = "#f5deb3";

/**
 * 白色。
 */
export const white = "#ffffff";

/**
 * 白烟色。
 */
export const whiteSmoke = "#f5f5f5";

/**
 * 黄色。
 */
export const yellow = "#ffff00";

/**
 * 黄绿色。
 */
export const yellowGreen = "#9acd32";
